import type { ProfileTheme, WheelId } from '@shared';
import type { IconName } from '../ui/Icon';

/**
 * The mark in the middle of the wheel.
 *
 * The hub is the one part of the wheel a viewer looks straight at while it
 * spins, so it is where a creator's emblem earns its place: a leaf for the elf,
 * a bat for the vampire. It is the cheapest signature the wheel has — no
 * artwork, one icon.
 *
 * The premium wheel keeps its crown on every theme. That icon is not decoration:
 * it is how a player tells the expensive wheel from the ordinary one at a
 * glance, and a theme must never be able to blur a distinction the player is
 * spending credits on.
 */
export const THEME_EMBLEMS: Record<ProfileTheme, IconName> = {
  spoyl: 'sparkles',
  elf: 'leaf',
  vampire: 'bat',
};

export function hubIconFor(theme: ProfileTheme, wheelId: WheelId): IconName {
  return wheelId === 'daily' ? 'crown' : THEME_EMBLEMS[theme];
}
